import React, { useCallback } from 'react';
import { color, image } from '@/theme';
import { PrimaryButton } from '@/components/button';
import { InputBasic, SelectInput } from '@/components/input';
import InputPhone from '@/components/input/InputPhone';
import { RegularText } from '@/components/text';
import { Image } from '@/components/shared';
import { useGetSegmentCategory } from '@/hooks/CommonRequests';
import { ButtonWrapper, InputRows, ButtonContent } from '../inquiry/inquryStyles';

const EventClientInformation = ({ control, setStep, trigger, errors }) => {
  const { data: segmentCategory } = useGetSegmentCategory();

  const onClickNextBtn = useCallback(async () => {
    const result = await trigger([
      'first_name',
      'last_name',
      'email',
      'phone',
      'company_name',
      'segment',
    ]);

    if (result) {
      setStep((prev) => prev + 1);
    }
  }, [trigger, setStep]);

  const goToPrev = useCallback(() => {
    setStep(0);
  }, [setStep]);

  return (
    <>
      <InputRows>
        <InputBasic
          control={control}
          name="first_name"
          label="lang-firstname"
          placeholder="lang-placeholder-firstname"
          required
          maxLength={15}
        />

        <InputBasic
          control={control}
          name="last_name"
          label="lang-lastname"
          placeholder="lang-placeholder-lastname"
          required
          maxLength={15}
        />
      </InputRows>

      <InputBasic
        control={control}
        name="email"
        label="lang-email"
        placeholder="lang-placeholder-email"
        required
        inputMode="email"
        maxLength={50}
      />

      <InputPhone
        control={control}
        name="phone"
        label="lang-phone"
        placeholder="lang-placeholder-phone"
        required
      />

      <InputBasic
        control={control}
        name="company_name"
        label="lang-company-name"
        placeholder="lang-placeholder-company"
        required
        maxLength={50}
      />

      <SelectInput
        control={control}
        errors={errors}
        name="segment"
        arr={segmentCategory}
        label="lang-placeholder-company-segment"
        required
      />

      <ButtonWrapper>
        <PrimaryButton type="button" onClick={goToPrev}>
          <ButtonContent>
            <Image src={image.arrowLeft.default} width="1.8rem" height="1.4rem" />

            <RegularText id="lang-prev" color={color.base_white} />
          </ButtonContent>
        </PrimaryButton>

        <PrimaryButton type="button" width="92%" onClick={onClickNextBtn}>
          <ButtonContent>
            <RegularText id="lang-inquiry-next" color={color.base_white} />

            <Image src={image.arrowRight.default} width="1.8rem" height="1.4rem" />
          </ButtonContent>
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default EventClientInformation;
